import styled from 'styled-components';
import { pageCard, pageCardTitle, shimmer } from '@/styles/mixins';

export const AddPaymentMethodFormWrapper = styled.section`
  ${pageCard};
  padding-inline: 2rem;

  .title {
    ${pageCardTitle};
  }

  .buttons {
    display: flex;
    gap: 0.875rem;
    justify-content: flex-end;
    padding-top: 2rem;
  }

  .other-payment-amounts {
    margin-bottom: 2rem;
  }
`;

export const PaymentSkeletonWrapper = styled.div`
  ${pageCard};
  padding-inline: 2rem;
  display: flex;
  flex-direction: column;

  .skeleton-title {
    height: 32px;
    width: 60%;
    margin-bottom: 0.5rem;
    border-radius: 4px;
    ${shimmer};
  }

  .skeleton-text {
    height: 20px;
    width: 40%;
    margin-bottom: 2rem;
    border-radius: 4px;
    ${shimmer};
  }

  .skeleton-form {
    height: 200px;
    width: 100%;
    border-radius: 4px;
    ${shimmer};
  }
`;
